import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import NextLink from 'next/link';
import { mediaQueries } from 'shared/styles';

type BannerImageWrapperProps = {
  children: ReactNode;
  linkUrl: string | null | undefined;
  isInternalRoute?: boolean;
  target: string | null | undefined;
  rel: string | null | undefined;
  onClick: () => void;
};

export function BannerImageWrapper({
  children,
  linkUrl,
  isInternalRoute = false,
  target,
  rel,
  onClick,
}: BannerImageWrapperProps): JSX.Element {
  if (linkUrl) {
    // Use Next.js Link for internal routes (client-side navigation)
    if (isInternalRoute) {
      return (
        <NextLink href={linkUrl} passHref legacyBehavior>
          <InternalLink href={linkUrl} onClick={onClick}>
            {children}
          </InternalLink>
        </NextLink>
      );
    }

    // Use regular anchor for external links
    return (
      <ExternalLink href={linkUrl} target={target} rel={rel} onClick={onClick}>
        {children}
      </ExternalLink>
    );
  }

  return <Container>{children}</Container>;
}

const imageWrapperStyle = css`
  max-width: 1200px;
  width: 100%;
  margin: 0;
  border-radius: var(--dct--customized-radius-lg);
  @media ${mediaQueries.largePhone} {
    margin: 0 10px;
    padding: 0 16px;
  }
`;

const ExternalLink = styled.a`
  ${imageWrapperStyle}
`;

const InternalLink = styled.a`
  ${imageWrapperStyle}
`;

const Container = styled.div`
  ${imageWrapperStyle}
`;
